import React from "react";
import GeneralSection from "../../newComponents/generalSection";

const cmsOrigin = new URL(import.meta.env.VITE_CRAFTGQL_URL).origin;

const imageStyles = {
  square: "w-28 h-24 p-4 bg-brand-green object-contain",
  circle: "w-24 h-24 rounded-full object-cover",
  none: "max-h-24 w-auto object-contain",
};

const columnWidths = {
  auto: "w-full sm:w-1/2 md:w-1/3 lg:w-1/5",
  2: "w-full sm:w-1/2",
  3: "w-full sm:w-1/2 md:w-1/3",
  4: "w-full sm:w-1/2 md:w-1/3 lg:w-1/4",
};

const CardGrid = ({ block }) => (
  <GeneralSection className="mb-8">
    {block.heading && <h2 className="section__title title h2 text-gray mb-4">{block.heading}</h2>}
    {block.intro && <div className="prose max-w-none mb-8" dangerouslySetInnerHTML={{ __html: block.intro }}/>}
    <div className="flex flex-wrap justify-center -mx-4">
      {block.cards.map((card) => (
        <div key={card.id} className={`${columnWidths[block.cardsPerRow] || columnWidths.auto} px-4 mb-8 flex flex-col items-center text-center`}>
          {card.image[0] && (
            <img
              src={card.image[0].url.startsWith("http") ? card.image[0].url : cmsOrigin + card.image[0].url}
              alt={card.image[0].title || ""}
              className={`mb-4 ${imageStyles[block.imageStyle] || imageStyles.square}`}
              loading="lazy"
            />
          )}
          {card.heading && <p className="text-lg leading-tight text-brand-green mb-3">{card.heading}</p>}
          {card.body && <div className="text-sm leading-snug [&_p]:mb-2" dangerouslySetInnerHTML={{ __html: card.body }}/>}
        </div>
      ))}
    </div>
  </GeneralSection>
);

export default CardGrid;
